const DEFAULT_METRICS = {
  totalInteractions: 0,
  averageServiceTime: "00:00",
  peakTrafficTime: "00:00",
  topRequests: [],
  topAttendants: [],
};

// Persistencia do checkout do staff em sessionStorage: mantem o resumo da
// compra (impostos, totais, itens do carrinho) apos um refresh (F5) na tela de
// pagamento, evitando a perda de dados e a quebra do front. Some ao fechar a aba.
const CHECKOUT_STORAGE_KEY = "InformaMarket:staffCheckout";

const getPersistedCheckout = () => {
  try {
    const raw = sessionStorage.getItem(CHECKOUT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const persistCheckout = (state) => {
  try {
    sessionStorage.setItem(
      CHECKOUT_STORAGE_KEY,
      JSON.stringify({
        checkoutInfo: state.checkoutInfo,
        cartProducts: state.cartProducts,
        currency: state.currency,
        orderNumber: state.orderNumber,
      })
    );
  } catch {
    // Falhas de storage nao devem quebrar a aplicacao.
  }
};

const clearPersistedCheckout = () => {
  try {
    sessionStorage.removeItem(CHECKOUT_STORAGE_KEY);
  } catch {
    // ignora
  }
};

const persistedCheckout = getPersistedCheckout();

const INITIAL_STATE = {
  contract: {
    label: null,
    value: null,
  },
  contractProducts: [],
  contractProductsLoaded: false,
  contractProductsError: null,

  products: [],
  productsLoaded: false,
  productsError: null,

  cartProducts: persistedCheckout?.cartProducts || [],
  checkoutInfo: persistedCheckout?.checkoutInfo || null,
  purchaseInfo: null,

  accountId: null,
  orderNumber: persistedCheckout?.orderNumber ?? null,
  currency: persistedCheckout?.currency || "BRL",
  CNPJ: "",
  taxClassification: "-",

  //admin
  events: [],
  eventsError: false,
  staffData: [],
  pageInfo: null,
  metrics: DEFAULT_METRICS,
};

const staff_access = (state = INITIAL_STATE, action) => {
  const { payload, type } = action;

  switch (type) {
    default:
      return { ...state };

    case "RESET_STAFF_ACCESS":
      return {
        ...state,
        events: [],
        eventsError: false,
        staffData: [],
        pageInfo: null,
        metrics: DEFAULT_METRICS,
      };

    case "GET_CONTRACT_PRODUCTS":
      return {
        ...state,
        contractProducts: [],
        contractProductsLoaded: false,
        contractProductsError: null,
      };
    case "GET_CONTRACT_PRODUCTS_SUCCESS":
      return {
        ...state,
        contractProducts: payload.productAcquiredDetailsDTO,
        contractProductsLoaded: true,
      };
    case "GET_CONTRACT_PRODUCTS_FAILURE":
      return {
        ...state,
        contractProducts: [],
        contractProductsLoaded: true,
        contractProductsError: payload.error,
      };

    case "GET_PRODUCTS_TO_CART":
      return {
        ...state,
        products: [],
        productsLoaded: false,
        productsError: null,
      };
    case "GET_PRODUCTS_TO_CART_SUCCESS": {
      const persistedCart = getPersistedCheckout()?.cartProducts || [];
      const qtyByCode = new Map(persistedCart.map((p) => [p.code, p.qty]));

      const products = payload.productsForSale.map((p) => ({
        title: {
          pt: p.title,
          en: p.englishTitle,
        },
        desc: {
          pt: p.description,
          en: p.englishDescription,
        },
        category: {
          id: p.categoryId,
          credentialType: p.credentialType,
          pt: p.categoryTitle,
          en: p.categoryEnglishTitle,
        },
        currency: p.currency,
        value: p.value,
        code: p.code,
        qty: qtyByCode.get(p.code) || 0,
        acquiredInContract: p.acquiredInContract,
      }));

      return {
        ...state,
        accountId: payload.accountId,
        currency: payload.productsForSale[0].currency,
        products,
        cartProducts: products.filter((p) => p.qty > 0),
        productsLoaded: true,
      };
    }
    case "GET_PRODUCTS_TO_CART_FAILURE":
      return {
        ...state,
        products: [],
        productsLoaded: true,
        productsError: payload.error,
      };

    case "UPDATE_PRODUCTS_TO_CART": {
      const newState = {
        ...state,
        cartProducts: payload.cart,
        products: payload.products,
      };

      persistCheckout(newState);
      return newState;
    }

    case "CHECKOUT_INFO": {
      const newState = {
        ...state,
        orderNumber: payload.data.orderNumber,
        checkoutInfo: {
          orderNumber: payload.data.orderNumber,
          discounts: Number(payload.data.discount.replace(",", ".")),
          totalValue: Number(payload.data.totalValue.replace(",", ".")),
          taxes: transformTaxes({
            cofins: payload.data.cofins,
            csll: payload.data.csll,
            ir: payload.data.ir,
            pis: payload.data.pis,
          }),
        },
      };
      persistCheckout(newState);
      return newState;
    }

    case "SAVE_PURCHASE_INFO": {
      const {
        name,
        document,
        phone,
        cardReader,
        paymentMethod,
        paymentStatus,
        brand,
      } = payload.data;

      const obj = {
        ...(state.purchaseInfo || {}),
        ...(name !== undefined && { name }),
        ...(document !== undefined && { document }),
        ...(phone !== undefined && { phone }),
        ...(cardReader !== undefined && { cardReader }),
        ...(paymentMethod !== undefined && { paymentMethod }),
        ...(paymentStatus !== undefined && { paymentStatus }),
        ...(brand !== undefined && { brand }),
      };

      return {
        ...state,
        purchaseInfo: obj,
      };
    }

    case "RESET_SALE_INFO_SUCCESS":
      clearPersistedCheckout();
      return {
        ...state,
        products: [],
        productsLoaded: false,
        cartProducts: [],
        checkoutInfo: null,
        purchaseInfo: null,
      };

    case "GET_CONTRACT_INFO":
      return {
        ...state,
        CNPJ: "",
        taxClassification: "-",
      };
    case "GET_CONTRACT_INFO_SUCCESS":
      return {
        ...state,
        CNPJ: payload.opportunity?.account?.accountGovCompanyCode,
        taxClassification: payload.opportunity?.account?.nationalClassification,
      };
    case "GET_CONTRACT_INFO_FAILURE":
      return {
        ...state,
        CNPJ: "",
        taxClassification: "-",
      };

    //Admin

    case "GET_EVENT_LIST_CAEX":
      return {
        ...state,
        eventsError: false,
        events: [],
      };
    case "GET_EVENT_LIST_SUCCESS":
      return {
        ...state,
        events: action.payload.events,
        eventsError: false,
      };
    case "GET_EVENT_LIST_FAILURE":
      return {
        ...state,
        eventsError: true,
        events: [],
      };

    case "GET_STAFF_ATTENDENCE_TABLE":
      return {
        ...state,
        pageInfo: null,
        staffData: [],
      };
    case "GET_STAFF_ATTENDENCE_TABLE_SUCCESS":
      return {
        ...state,
        pageInfo: action.payload.pageInfo,
        staffData: action.payload.staffData,
      };
    case "GET_STAFF_ATTENDENCE_TABLE_FAILURE":
      return {
        ...state,
        pageInfo: null,
        staffData: [],
      };

    case "GET_STAFF_ATTENDENCE_INFO":
      return {
        ...state,
        metrics: DEFAULT_METRICS,
      };
    case "GET_STAFF_ATTENDENCE_INFO_SUCCESS":
      return {
        ...state,
        metrics: action.payload.metrics,
      };
    case "GET_STAFF_ATTENDENCE_INFO_FAILURE":
      return {
        ...state,
        metrics: DEFAULT_METRICS,
      };
  }
};

export default staff_access;

function transformTaxes(taxes) {
  const taxLabels = {
    ir: "IR",
    pis: "PIS",
    cofins: "COFINS",
    csll: "CSLL",
  };

  return Object.entries(taxes).map(([key, value]) => ({
    label: taxLabels[key],
    value: Number(value.replace(",", ".")),
  }));
  // .sort((a, b) => a.label.localeCompare(b.label));
}
